import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home2.vue'
import Telescope from '../views/Telescope.vue'
import Share from '../views/Share.vue'
import About from '../views/About.vue'
import Pricing from '../views/Pricing.vue'
import Service from '../views/Service.vue'
// import Download2 from '../views/DownloadV2.vue'
// import Download from '../views/Download.vue'
// import Download from '../views/DownloadV4.vue'
import Download from '../views/DownloadV5.vue'
import Support from '../views/Support.vue'
import Support1 from '../views/Support1.vue'
import Support2 from '../views/Support2.vue'
import Support3 from '../views/Support3.vue'
import Support4 from '../views/Support4.vue'
import Support5 from '../views/Support5.vue'
import Support6 from '../views/Support6.vue'
import Answer from '../views/Answer.vue'
import News from '../views/News.vue'
import NewsDetail from '../views/NewsDetail.vue'
import NewsTag from '../views/NewsTag.vue'
import QueryTwmDevice from '../views/QueryTwmDevice.vue'
import QueryWltDevice from '../views/QueryWltDevice.vue'
import QueryQhDevice from '../views/QueryQhDevice.vue'
import Singin from '../views/Singin.vue'
import Help from '../views/Help.vue'
import UpdateLog from '../views/Update/update_log.vue'
import TunNetwork from '../views/Introduce/tunNetwork.vue'
import AlbumBackup from '../views/Introduce/albumBackup.vue'
import RemoteFiles from '../views/Introduce/remoteFiles.vue'
import RemoteDesktop from '../views/Introduce/remoteDesktop.vue'
import ShareNetwork from '../views/Introduce/shareNetwork.vue'
import IntranetPenetration from '../views/Introduce/intranetPenetration.vue'
import store from '../store';



Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: {
      title: '节点小宝 - 免费内网穿透与异地组网工具|P2P远程访问NAS',
      description: '节点小宝是一款免费的内网穿透与异地组网工具，基于自研P2P技术实现设备直连，无需公网IP，不限速。支持NAS远程访问、远程桌面、SSH、Docker管理、文件共享等场景。',
      keywords: '节点小宝,节点小宝官网,内网穿透,异地组网,远程访问,NAS远程,P2P直连,无需公网IP,远程桌面,远程办公'
    },
  },
  {
    path: '/telescope',
    name: 'Telescope',
    component: Telescope,
    meta: {
      title: '节点小宝远程监控 - 设备状态实时查看|远程管理工具',
      description: '节点小宝远程监控功能，实时查看所有已连接设备的在线状态、网络质量和连接速度，轻松掌控异地设备运行情况。',
      keywords: '远程监控,设备管理,在线状态,节点小宝,节点小宝官网,远程管理,设备状态查看'
    },
  },
  {
    path: '/share',
    name: 'Share',
    component: Share,
    meta: {
      title: '节点小宝文件共享 - 远程文件传输与共享|不限速',
      description: '节点小宝文件共享功能，基于P2P直连技术实现远程文件传输与共享，不限速、不限量，轻松共享大文件到异地设备。',
      keywords: '文件共享,远程传输,文件同步,不限速,节点小宝,节点小宝官网,P2P传输,大文件传输'
    },
  },
  {
    path: '/download',
    name: 'Download',
    component: Download,
    meta: {
      title: '节点小宝下载 - 支持Windows/macOS/Linux/Android/iOS客户端',
      description: '下载节点小宝客户端，支持Windows、macOS、Linux、Android、iOS等主流平台，即装即用，一键开启内网穿透与异地组网。',
      keywords: '节点小宝,节点小宝官网,节点小宝下载,内网穿透下载,客户端下载,Windows,macOS,Linux,Android,iOS,免费远程工具'
    },
  },
  {
    path: '/about',
    name: 'About',
    component: About,
    meta: {
      title: '关于节点小宝 - 8年专注远程连接与内网穿透技术',
      description: '节点小宝团队8年专注远程连接云服务与内网穿透技术，基于全自主研发的P2P技术，为用户提供安全、高速、稳定的异地组网解决方案。',
      keywords: '关于节点小宝,节点小宝官网,远程连接,内网穿透技术,P2P技术,异地组网,云服务'
    },
  },
  {
    // 老的企业版页面已下线，/business 也指向新定价页（老 Buy.vue 仅保留源码，不再挂路由）
    path: '/business',
    name: 'Buy',
    component: Pricing,
    meta: {
      title: '节点小宝价格 - 体验版/尊享版/专业版套餐对比',
      description: '查看节点小宝各版本套餐价格，提供体验版、尊享版和专业版，灵活满足个人、家庭与团队的内网穿透与异地组网需求。',
      keywords: '节点小宝,节点小宝官网,节点小宝价格,内网穿透价格,套餐对比,体验版,尊享版,专业版,性价比'
    },
  },
  {
    path: '/pricing',
    name: 'Pricing',
    component: Pricing,
    meta: {
      title: '节点小宝价格 - 体验版/尊享版/专业版套餐对比',
      description: '查看节点小宝各版本套餐价格，提供体验版、尊享版和专业版，灵活满足个人、家庭与团队的内网穿透与异地组网需求。',
      keywords: '节点小宝,节点小宝官网,节点小宝价格,内网穿透价格,套餐对比,体验版,尊享版,专业版,性价比'
    },
  },
  {
    path: '/service',
    name: 'Service',
    component: Service,
    meta: {
      title: '节点小宝服务 - 技术支持与售后保障',
      description: '节点小宝提供专业技术支持与售后保障服务，包括使用指导、故障排查、定制化方案等，确保您的远程连接稳定可靠。',
      keywords: '技术支持,售后服务,使用指导,节点小宝,节点小宝官网,节点小宝服务,远程协助,故障排查'
    },
  },
  {
    path: '/answer',
    beforeEnter() {
      window.location.href = "https://iepose.com/helpcenter_v3/";
    },
  },
  {
    path: '/help',
    name: 'Help',
    beforeEnter() {
      window.location.href = "https://iepose.com/helpcenter_v3/";
    },
    meta: {
      title: '节点小宝帮助中心 - 使用教程与常见问题解答',
      description: '节点小宝帮助中心提供详细的使用教程、配置指南和常见问题解答，助您快速上手内网穿透与异地组网功能。',
      keywords: '使用教程,常见问题,配置指南,帮助中心,节点小宝,节点小宝官网,内网穿透教程'
    },
  },
  {
    path: '/twm/device/query',
    name: 'TwmDeviceQuery',
    component: QueryTwmDevice,
    meta: {
      title: '节点小宝设备查询 - 铁威马',
      description: '节点小宝是一款免费的内网穿透与异地组网工具，基于自研P2P技术实现设备直连，无需公网IP，不限速。支持NAS远程访问、远程桌面、SSH、Docker管理、文件共享等场景。',
      keywords: '节点小宝,节点小宝官网,内网穿透,异地组网,远程访问,NAS远程,P2P直连,无需公网IP,远程桌面,远程办公'
    },
  },
  {
    path: '/wlt/device/query',
    name: 'WltDeviceQuery',
    component: QueryWltDevice,
    meta: {
      title: '节点小宝设备查询 - 威联通',
      description: '节点小宝是一款免费的内网穿透与异地组网工具，基于自研P2P技术实现设备直连，无需公网IP，不限速。支持NAS远程访问、远程桌面、SSH、Docker管理、文件共享等场景。',
      keywords: '节点小宝,节点小宝官网,内网穿透,异地组网,远程访问,NAS远程,P2P直连,无需公网IP,远程桌面,远程办公'
    },
  },
  {
    path: '/qh/device/query',
    name: 'QhDeviceQuery',
    component: QueryQhDevice,
    meta: {
      title: '节点小宝设备查询 - 群晖',
      description: '节点小宝是一款免费的内网穿透与异地组网工具，基于自研P2P技术实现设备直连，无需公网IP，不限速。支持NAS远程访问、远程桌面、SSH、Docker管理、文件共享等场景。',
      keywords: '节点小宝,节点小宝官网,内网穿透,异地组网,远程访问,NAS远程,P2P直连,无需公网IP,远程桌面,远程办公'
    },
  },
  {
    path: '/support',
    name: 'Support',
    component: Support,
    meta: {
      title: '节点小宝帮助中心 - 使用教程与常见问题解答',
      description: '节点小宝帮助中心提供详细的使用教程、配置指南和常见问题解答，助您快速上手内网穿透与异地组网功能。',
      keywords: '使用教程,常见问题,配置指南,帮助中心,节点小宝,节点小宝官网,内网穿透教程'
    },
  },
  {
    path: '/support/1',
    name: 'Support1',
    component: Support1,
    meta: {
      title: '节点小宝帮助中心 - 使用教程与常见问题解答',
      description: '节点小宝帮助中心提供详细的使用教程、配置指南和常见问题解答，助您快速上手内网穿透与异地组网功能。',
      keywords: '使用教程,常见问题,配置指南,帮助中心,节点小宝,节点小宝官网,内网穿透教程'
    },
  },
  {
    path: '/support/2',
    name: 'Support2',
    component: Support2,
    meta: {
      title: '节点小宝帮助中心 - 使用教程与常见问题解答',
      description: '节点小宝帮助中心提供详细的使用教程、配置指南和常见问题解答，助您快速上手内网穿透与异地组网功能。',
      keywords: '使用教程,常见问题,配置指南,帮助中心,节点小宝,节点小宝官网,内网穿透教程'
    },
  },
  {
    path: '/support/3',
    name: 'Support3',
    component: Support3,
    meta: {
      title: '节点小宝帮助中心 - 使用教程与常见问题解答',
      description: '节点小宝帮助中心提供详细的使用教程、配置指南和常见问题解答，助您快速上手内网穿透与异地组网功能。',
      keywords: '使用教程,常见问题,配置指南,帮助中心,节点小宝,节点小宝官网,内网穿透教程'
    },
  },
  {
    path: '/support/4',
    name: 'Support4',
    component: Support4,
    meta: {
      title: '节点小宝帮助中心 - 使用教程与常见问题解答',
      description: '节点小宝帮助中心提供详细的使用教程、配置指南和常见问题解答，助您快速上手内网穿透与异地组网功能。',
      keywords: '使用教程,常见问题,配置指南,帮助中心,节点小宝,节点小宝官网,内网穿透教程'
    },
  },
  {
    path: '/support/5',
    name: 'Support5',
    component: Support5,
    meta: {
      title: '节点小宝帮助中心 - 使用教程与常见问题解答',
      description: '节点小宝帮助中心提供详细的使用教程、配置指南和常见问题解答，助您快速上手内网穿透与异地组网功能。',
      keywords: '使用教程,常见问题,配置指南,帮助中心,节点小宝,节点小宝官网,内网穿透教程'
    },
  },
  {
    path: '/support/6',
    name: 'Support6',
    component: Support6,
    meta: {
      title: '节点小宝帮助中心 - 使用教程与常见问题解答',
      description: '节点小宝帮助中心提供详细的使用教程、配置指南和常见问题解答，助您快速上手内网穿透与异地组网功能。',
      keywords: '使用教程,常见问题,配置指南,帮助中心,节点小宝,节点小宝官网,内网穿透教程'
    },
  },
  {
    path: '/news',
    name: 'News',
    component: News,
    meta: {
      title: '节点小宝资讯中心 - 最新资讯动态与使用教程',
      description: '节点小宝资讯中心，分享节点小宝最新企业资讯、产品动态以及行业前沿技术，帮助您了解最新功能与使用教程。',
      keywords: '节点小宝资讯,最新资讯,资讯中心,节点小宝动态,产品资讯,节点小宝官网'
    },
  },
  {
    path: '/news/detail/:id',
    name: 'NewsDetail',
    component: NewsDetail,
    meta: {
      title: '节点小宝资讯详情',
      description: '节点小宝资讯详情',
      keywords: '节点小宝,节点小宝官网,资讯,教程'
    },
  },
  {
    path: '/news/tag/:tagId',
    name: 'NewsTag',
    component: NewsTag,
    meta: {
      title: '节点小宝资讯 - 标签相关文章',
      description: '节点小宝资讯 - 标签相关文章',
      keywords: '节点小宝,节点小宝官网,资讯,教程,标签'
    },
  },
  {
    path: '/update',
    name: 'UpdateLog',
    component: UpdateLog,
    meta: {
      title: '节点小宝更新日志 - 功能与体验持续升级',
      description: '节点小宝更新日志，持续进行功能和体验升级，包括团队网络、客户端访问授权、远程桌面等功能的新增、优化与修复。',
      keywords: '更新日志,节点小宝,版本更新,功能升级,团队网络,客户端访问授权,远程桌面'
    },
  },
  {
    path: '/changelog',
    name: 'UpdateLog',
    component: UpdateLog,
    meta: {
      title: '节点小宝更新日志 - 功能与体验持续升级',
      description: '节点小宝更新日志，持续进行功能和体验升级，包括团队网络、客户端访问授权、远程桌面等功能的新增、优化与修复。',
      keywords: '更新日志,节点小宝,版本更新,功能升级,团队网络,客户端访问授权,远程桌面'
    },
  },
  {
    path: '/introduce/tunNetwork',
    name: 'TunNetwork',
    component: TunNetwork,
    meta: {
      title: '异地组网 - 随时随地，全设备互通互联|节点小宝',
      description: '通过绑定设备即自动组网，账户下的设备可通过组网地址互通互联，支持自定组网与网段组网，轻松访问远程局域网的设备与服务。P2P直连、全程加密、支持Windows/macOS/Android/iOS/Linux/NAS等全平台。',
      keywords: '异地组网,自动组网,自定义组网,全网映射,小宝网关,内网穿透,远程访问,节点小宝,节点小宝官网'
    },
  },
  {
    path: '/introduce/albumBackup',
    name: 'AlbumBackup',
    component: AlbumBackup,
    meta: {
      title: '相册备份 - 手机照片视频自动备份到私有设备|节点小宝',
      description: 'iPhone/Android手机可将原始照片与视频，自动备份到已绑定的设备中，无需依赖公有云，让你的私有相册存储与管理更轻松。原片无损备份、自动同步、释放手机空间、数据自主可控。',
      keywords: '相册备份,照片备份,视频备份,私有相册,自动备份,原片无损,空间释放,节点小宝,节点小宝官网'
    },
  },
  {
    path: '/introduce/remoteFiles',
    name: 'RemoteFiles',
    component: RemoteFiles,
    meta: {
      title: '远程文件 - 随时随地访问你的文件，跨端跨网传输|节点小宝',
      description: '使用节点小宝访问远程设备中的文件，支持浏览文件夹、上传与下载文件，Windows/macOS客户端还可将远程文件夹挂载到本地，像本地磁盘一样使用。权限控制，数据加密传输。',
      keywords: '远程文件,文件挂载,远程访问,文件传输,跨平台文件,权限控制,节点小宝,节点小宝官网'
    },
  },
  {
    path: '/introduce/remoteDesktop',
    name: 'RemoteDesktop',
    component: RemoteDesktop,
    meta: {
      title: '远程桌面 - 随时随地远程连接你的电脑，跨平台操控|节点小宝',
      description: '通过节点小宝客户端远程访问并控制电脑。出门在外也能轻松操作家中、办公或云端主机；跨平台连接、高清流畅、操作便捷，数据传输端到端加密，安全可靠。',
      keywords: '远程桌面,远程控制,远程办公,远程操控,远程运维,跨平台,节点小宝,节点小宝官网'
    },
  },
  {
    path: '/introduce/shareNetwork',
    name: 'ShareNetwork',
    component: ShareNetwork,
    meta: {
      title: '共享网络 - 局域网资源，一键共享给团队|节点小宝',
      description: '将指定设备所在局域网中的任意IP及端口共享给成员。邀请成员并完成授权后，成员即可通过共享地址访问目标设备或服务，支持端口共享、成员授权与精细化访问控制。',
      keywords: '共享网络,局域网共享,端口共享,团队协作,成员授权,资源共享,节点小宝,节点小宝官网'
    },
  },
  {
    path: '/introduce/nat',
    name: 'IntranetPenetration',
    component: IntranetPenetration,
    meta: {
      title: '内网穿透 - 无需公网IP，将内网服务安全发布到公网|节点小宝',
      description: '通过已绑定的节点小宝设备，将设备本地或局域网的网页及服务，如个人站点、博客、NAS、OA、终端、数据库等，发布为可在互联网上安全访问的域名。20秒快速上线，多维度访问控制。',
      keywords: '内网穿透,公网访问,域名发布,NAS访问,免公网IP,OA系统,个人站点,节点小宝,节点小宝官网'
    },
  },
  {
    path: '/singin',
    name: 'Singin',
    component: Singin,
    meta: {
      title: '惺灵 - 免费内网穿透与异地组网工具|P2P远程访问NAS',
      description: '节点小宝是一款免费的内网穿透与异地组网工具，基于自研P2P技术实现设备直连，无需公网IP，不限速。支持NAS远程访问、远程桌面、SSH、Docker管理、文件共享等场景。',
      keywords: '节点小宝,节点小宝官网,内网穿透,异地组网,远程访问,NAS远程,P2P直连,无需公网IP,远程桌面,远程办公'
    },
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.NODE_ENV === 'production' ? "/jdxb/pc/" : process.env.BASE_URL,
  routes
})

// 动态更新页面 meta 标签（title / description / keywords / og / canonical）
router.beforeEach((to, from, next) => {
  const { title, description, keywords } = to.meta || {}

  // 设置 title
  document.title = title || '节点小宝 - 免费内网穿透与异地组网工具'

  // 动态更新 description
  let descMeta = document.querySelector('meta[name="description"]')
  if (descMeta && description) {
    descMeta.setAttribute('content', description)
  }

  // 动态更新 keywords
  let kwMeta = document.querySelector('meta[name="keywords"]')
  if (kwMeta && keywords) {
    kwMeta.setAttribute('content', keywords)
  }

  // 动态更新 og:title
  let ogTitle = document.querySelector('meta[property="og:title"]')
  if (ogTitle && title) {
    ogTitle.setAttribute('content', title)
  }

  // 动态更新 og:description
  let ogDesc = document.querySelector('meta[property="og:description"]')
  if (ogDesc && description) {
    ogDesc.setAttribute('content', description)
  }

  // 动态更新 canonical URL
  let canonical = document.querySelector('link[rel="canonical"]')
  if (canonical) {
    const baseUrl = 'https://iepose.com/jdxb/pc'
    const path = to.path === '/' ? '' : to.path
    canonical.setAttribute('href', baseUrl + path)
  }

  next()
})

export default router
